// MemberForm.jsx
import React, { useState } from "react";
import { inviteMember } from "../../api/api";
import "./MemberForm.css";

const MemberForm = ({ workspace_id, onMemberCreated }) => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return alert("Email required");

    setLoading(true);
    try {
      await inviteMember(workspace_id, email, role);
      alert(`Member added successfully. Password sent to ${email}.`);
      onMemberCreated();
      setEmail("");
      setRole("member");
    } catch (err) {
      console.error(err);
      alert(err.msg || "Failed to add member");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="member-form">
      <div className="form-group">
        <label className="form-label">
          <svg className="form-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          Email Address
        </label>
        <input
          type="email"
          className="form-input"
          placeholder="member@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">
          <svg className="form-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          Role
        </label>
        <select
          className="form-select"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="member">Member</option>
          <option value="admin">Admin</option>
          <option value="viewer">Viewer</option>
        </select>
      </div>

      <button type="submit" className="submit-button" disabled={loading}>
        {loading ? (
          <>
            <svg className="loading-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12a9 9 0 11-6.219-8.56" />
            </svg>
            Adding...
          </>
        ) : (
          <>
            <svg className="button-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Invite Member
          </>
        )}
      </button>
    </form>
  );
};

export default MemberForm;